import { useCallback } from 'react';

import type { CallbackData } from '#src/app/pages/petitionDetails/shared/types';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useTrackingSignData } from '#src/app/shared/hooks/signature';

import { useSignData } from '../useSignData';

export function useGetMetaData(): (data: CallbackData) => Record<string, unknown> {
	const alertId = useQueryParamValue('alert_id');
	const trackingSignData = useTrackingSignData({ bandits: true });
	const signData = useSignData();

	return useCallback(
		() => ({
			reasons_for_signing_completed: false,
			mit_or_fht_utm_content: trackingSignData.mitTrackingValue || trackingSignData.fhtTrackingValue,
			algorithm: signData.algorithm,
			source_location: signData.sourceLocation,
			alert_id: alertId,
			traffic_metadata: {
				current_source: trackingSignData.trafficMetadata?.currentSource,
				current_medium: trackingSignData.trafficMetadata?.currentMedium,
				referring_domain: trackingSignData.trafficMetadata?.referringDomain,
			},
		}),
		[signData, trackingSignData, alertId],
	);
}
